/**
 * Role definitions mapping DB title values to display labels and IDs.
 * DB stores: "admin" (id=2), "user" (id=1), "private_user" (id=3)
 */

interface RoleDefinition {
  readonly id: number
  readonly value: string
  readonly label: string
}

export const ROLES: readonly RoleDefinition[] = [
  { id: 2, value: 'admin', label: 'Admin' },
  { id: 1, value: 'user', label: 'User' },
  { id: 3, value: 'private_user', label: 'Private User' },
] as const

const displayMap = new Map(ROLES.map((r) => [r.value, r.label]))
const idByValue = new Map(ROLES.map((r) => [r.value, r.id]))

/** Convert DB role value (e.g. "private_user") to display label (e.g. "Private User") */
export const roleToDisplay = (dbValue: string): string =>
  displayMap.get(dbValue) ?? dbValue

/** Convert DB role value to role ID (e.g. "admin" -> 2) */
export const roleToId = (dbValue: string): number => idByValue.get(dbValue) ?? 1
